import "./App.css";
import ResponsiveAppBar from "./components/ResponsiveAppBar";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/home";
import About from "./pages/about";
// import Map from './pages/map';
import Explore from "./pages/explore";
import Overview from "./pages/overview";
import Maps from "./pages/maps";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ResponsiveAppBar />
        <div className="Routes">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/overview" element={<Overview />} />
            <Route path="/explore" element={<Explore />} />
            <Route path="/explore/:tripId" element={<Explore />} />
            <Route path="/maps" element={<Maps />} />
            <Route path="/maps/:tripId" element={<Maps />} />
          </Routes>
        </div>
      </BrowserRouter>
    </div>
  );
}

export default App;
